import { styled } from "styled-components";

export const Container = styled.div`
  position: relative;
  width: 100%;
`;

export const Trigger = styled.button<{ disabled: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 12px;
  background-color: ${props => props.disabled ? 'var(--color-neutral-10)' : 'var(--color-neutral-10)'};
  border: 1px solid var(--color-neutral-10);
  border-radius: var(--border-radius-default);
  font-family: var(--font-family-body);
  font-size: var(--font-size-30);
  color: ${props => props.disabled ? 'var(--color-neutral-50)' : 'inherit'};
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: box-shadow 150ms var(--bezier-a);

  &:focus {
    background-color: var(--color-white);
    border: 1px solid var(--color-primary-50);
    box-shadow: 0px 0px 0px 3px var(--color-primary-20);
    outline: 0;
  }

  &:hover:not(:disabled) {
    background-color: var(--color-neutral-5);
  }
`;

export const TriggerText = styled.span<{ disabled: boolean }>`
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
  color: ${props => props.disabled ? 'var(--color-neutral-50)' : 'inherit'};
`;

export const ChevronIcon = styled.div<{ $isOpen: boolean }>`
  width: 16px;
  height: 16px;
  margin-left: 8px;
  transform: ${props => props.$isOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
  transition: transform 200ms ease;
  color: var(--color-neutral-50);

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const DropdownContainer = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: var(--color-white);
  border: 1px solid var(--color-neutral-20);
  border-radius: var(--border-radius-default);
  box-shadow: var(--box-shadow-30);
  max-height: 300px;
  overflow-y: auto;
  margin-top: 2px;
`;

export const DropdownHeader = styled.div`
  border-bottom: 1px solid var(--color-neutral-10);
`;

export const SelectAllOption = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 16px;
  cursor: pointer;
  font-weight: 500;

  &:hover {
    background-color: var(--color-neutral-5);
  }
`;

export const OptionsList = styled.div`
  max-height: 200px;
  overflow-y: auto;
`;

export const Option = styled.div<{ $selected: boolean }>`
  display: flex;
  align-items: center;
  padding: 12px 16px;
  cursor: pointer;
  background-color: ${props => props.$selected ? 'var(--color-primary-10)' : 'transparent'};

  &:hover {
    background-color: var(--color-neutral-5);
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const Checkbox = styled.div<{ $checked: boolean; $indeterminate?: boolean }>`
  width: 20px;
  height: 20px;
  margin-right: 12px;
  border: 2px solid var(--color-neutral-30);
  border-radius: var(--border-radius-10);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background-color: ${props => 
    props.$checked 
      ? 'var(--color-primary-50)' 
      : props.$indeterminate 
        ? 'var(--color-primary-50)' 
        : 'transparent'
  };
  border-color: ${props => 
    props.$checked || props.$indeterminate 
      ? 'var(--color-primary-50)' 
      : 'var(--color-neutral-30)'
  };

  svg {
    width: 12px;
    height: 12px;
    color: var(--color-white);
  }
`;

export const IndeterminateIcon = styled.span`
  color: var(--color-white);
  font-size: 16px;
  line-height: 1;
  font-weight: bold;
`;

export const OptionLabel = styled.span`
  flex: 1;
  font-size: var(--font-size-30);
`;
